module.exports = __webpack_public_path__ + "img/closeOverImgOne.d8e375b7.png";